import { themeButtonAppearance } from "./themeRegistry";

const PAGE_LINKS = [
  { value: "/", label: "Home" },
  { value: "/collection", label: "Collections" },
  { value: "/track-order", label: "Track order" },
  { value: "/about", label: "About" },
  { value: "/contact", label: "Contact" },
  { value: "/wishlist", label: "Wishlist" },
  { value: "/cart", label: "Cart" },
];

export const CART_PAGE_LINKS = PAGE_LINKS;
export const MAX_CART_LINKS = 6;

function textOr(value, fallback) {
  const next = typeof value === "string" ? value.trim() : "";
  return next || fallback;
}

function shown(value, fallback = true) {
  if (value === undefined || value === null || value === "") return fallback;
  return value !== false && value !== "false";
}

export function createCartLink(partial = {}) {
  return {
    id: partial.id || `cart_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    label: partial.label || "New link",
    link: partial.link || "/",
  };
}

export function cartDrawerSettings(settings = {}) {
  const menus = Array.isArray(settings.cartMenus) ? settings.cartMenus : [];
  const themeButton = themeButtonAppearance(settings);
  return {
    showRecommendations: shown(settings.cartShowRecommendations, true),
    recommendationsTitle: textOr(settings.cartRecommendationsTitle, "You may also like"),
    side: settings.cartSide === "left" ? "left" : "right",
    background: settings.cartBackground || "#ffffff",
    headingColor: settings.cartHeadingColor || "#111827",
    textColor: settings.cartTextColor || "#6b7280",
    iconColor: settings.cartIconColor || settings.accentColor || "#2563eb",
    itemBackground: settings.cartItemBackground || "#ffffff",
    itemBorder: settings.cartItemBorder || "#e5e7eb",
    itemName: settings.cartItemNameColor || settings.cartHeadingColor || "#111827",
    itemPrice: settings.cartItemPriceColor || settings.accentColor || "#2563eb",
    itemOldPrice: settings.cartItemOldPriceColor || "#9ca3af",
    removeColor: settings.cartRemoveColor || "#dc2626",
    qtyBackground: settings.cartQtyBackground || "#f3f4f6",
    qtyText: settings.cartQtyTextColor || settings.cartHeadingColor || "#111827",
    subtotalLabel: textOr(settings.cartSubtotalLabel, "Subtotal"),
    subtotalLabelColor: settings.cartSubtotalLabelColor || settings.cartTextColor || "#6b7280",
    subtotalColor: settings.cartSubtotalColor || settings.cartHeadingColor || "#111827",
    savingsLabel: textOr(settings.cartSavingsLabel, "Discount Savings"),
    savingsColor: settings.cartSavingsColor || "#15803d",
    shippingBackground: settings.cartShippingBackground || "#f8fafc",
    shippingText: settings.cartShippingTextColor || settings.cartHeadingColor || "#111827",
    shippingFreeColor: settings.cartShippingFreeColor || "#15803d",
    shippingBar: settings.cartShippingBarColor || "#16a34a",
    shippingFree: textOr(settings.cartShippingFree, "FREE Delivery on All Orders!"),
    shippingUnlocked: textOr(settings.cartShippingUnlocked, "You unlocked FREE Nationwide Delivery!"),
    shippingAdd: textOr(settings.cartShippingAdd, "Add {amount} for Free Shipping"),
    shippingAddColor: settings.cartShippingAddColor || settings.cartShippingTextColor || settings.cartHeadingColor || "#111827",
    linkColor: settings.cartLinkColor || settings.cartTextColor || "#6b7280",
    heading: textOr(settings.cartHeading, "Your Cart"),
    emptyTitle: textOr(settings.cartEmptyTitle, "Your cart is empty"),
    emptyMessage: textOr(settings.cartEmptyMessage, "Add items from our store to start checkout."),
    emptyButton: textOr(settings.cartEmptyButton, "Explore Collections"),
    checkoutLabel: textOr(settings.cartCheckoutLabel, "Checkout"),
    viewCartLabel: textOr(settings.cartViewLabel, "View Full Cart"),
    note: typeof settings.cartNote === "string" ? settings.cartNote.trim() : "Taxes and shipping calculated at checkout",
    showShipping: shown(settings.cartShowShipping, true),
    showSavings: shown(settings.cartShowSavings, true),
    showViewCart: shown(settings.cartShowViewCart, true),
    checkoutBackground: settings.cartCheckoutColor || themeButton.backgroundColor,
    checkoutText: settings.cartCheckoutTextColor || themeButton.color,
    checkoutBorder: settings.cartCheckoutBorderColor || settings.cartCheckoutColor || themeButton.backgroundColor,
    checkoutRadius: themeButton.borderRadius,
    viewBackground: settings.cartViewColor || "#ffffff",
    viewText: settings.cartViewTextColor || "#111827",
    viewBorder: settings.cartViewBorderColor || settings.cartViewTextColor || "#111827",
    menus: menus.filter((item) => item && String(item.label || "").trim() && String(item.link || "").trim()),
  };
}

export function cartShippingLine(look, threshold, remaining) {
  if (Number(threshold) === 0) return look.shippingFree;
  if (Number(remaining) === 0) return look.shippingUnlocked;
  const amount = `Rs. ${Number(remaining).toLocaleString()}`;
  return String(look.shippingAdd || "Add {amount} for Free Shipping").replace("{amount}", amount);
}
